/**
 * AI Translations Disclaimer Text.
 */
import { Component, registerComponent } from 'js/component.js';

const componentName = 'ai-translations-disclaimer-text';

export class AiTranslationDisclaimer extends Component {
    /**
     * Initialize Component
     */
    init() {
        document.querySelector('main').appendChild(this.element);
    }
}

registerComponent(`.${componentName}`, AiTranslationDisclaimer);
